import classNames from 'classnames/bind';
import styles from './Home.module.scss';
import Button from '../../components/Button';
import Card, { CardHeader } from '../../components/Card';
import { useNavigate } from 'react-router-dom';
import { getUser, setIsNotified } from '../../state/app/appActions';
import { useEffect } from 'react';
import Footer from '../../components/Footer';

const cx = classNames.bind(styles);

export interface HomeProps {
  isLoading: boolean;
  userId?: string;
  setIsNotified: typeof setIsNotified;
  getUser: typeof getUser;
}

const Home = (props: HomeProps) => {
  const { isLoading, userId, setIsNotified, getUser } = props;

  const navigate = useNavigate();

  const onProceed = () => {
    setIsNotified(true);
    navigate('/enrollment');
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className={cx('home')}>
      <Card className={cx('home__card')}>
        <CardHeader title="Important Notification" />
        <div className={cx('home__body')}>
          <div className={cx('home__content')}>
            <span className={cx('home__subtitle')}>Your CCC will change.</span>
            <span className={cx('home__text', 'home__text--bold')}>
              Please plan the timing of your enrollment accordingly to lessen
              the impact to upcoming filings.
              <br />
              <br />
            </span>
            <span className={cx('home__text')}>
              Upon completing this enrollment, your existing CIK Confirmation
              Code(s) (CCC){' '}
              <span className={cx('home__text--underlined')}>will change</span>.
              <br />
              <br />
              The new CCC code is required to submit filings hereforward and
              will need to be included for future filings to be accepted by the
              SEC.
              <br />
              <br />A link with instructions on how to obtain your new CCC will
              be provided to you at the end the enrollment process.
            </span>
          </div>
          <div className={cx('home__content')}>
            <span className={cx('home__subtitle')}>Submission hours.</span>
            <span className={cx('home__text')}>
              The EDGAR system is open for new enrollments from 6am to 10pm ET
              except weekends and federal holidays.
              <br />
              <br />
              Outside of these hours, you can still work in the system and save
              enrollment progress, but you must submit your enrollment during
              open hours.
            </span>
          </div>
        </div>
        <div className={cx('home__footer')}>
          <Button onClick={onProceed} isLoading={isLoading} disabled={!userId}>
            Proceed
          </Button>
          <div className={cx('home__disclaimer')}>
            by continuing, you agree to the
            <a
              href="https://www.dfinsolutions.com/enrollmentportal-dfin-standard-terms-and-conditions"
              className={cx('home__disclaimer-link')}
              target="_blank"
              rel="noreferrer"
            >
              terms and conditions
            </a>
          </div>
        </div>
      </Card>
      <Footer />
    </div>
  );
};

export default Home;
